<template>
  <div class="dashboard">
    <div class="dashboard-header">
      <h2>系统概览</h2>
      <p>欢迎回来，管理员！今日数据统计如下</p>
    </div>

    <div class="stats-cards">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-card class="stat-card" shadow="hover">
            <div class="stat-content">
              <div class="stat-icon" style="background-color: #40c9c6;">
                <i class="el-icon-user"></i>
              </div>
              <div class="stat-info">
                <div class="stat-value">{{ userCount }}</div>
                <div class="stat-label">注册用户</div>
              </div>
            </div>
          </el-card>
        </el-col>

        <el-col :span="6">
          <el-card class="stat-card" shadow="hover">
            <div class="stat-content">
              <div class="stat-icon" style="background-color: #36a3f7;">
                <i class="el-icon-video-camera"></i>
              </div>
              <div class="stat-info">
                <div class="stat-value">{{ videoCount }}</div>
                <div class="stat-label">学习内容</div>
              </div>
            </div>
          </el-card>
        </el-col>

        <el-col :span="6">
          <el-card class="stat-card" shadow="hover">
            <div class="stat-content">
              <div class="stat-icon" style="background-color: #f4516c;">
                <i class="el-icon-notebook-2"></i>
              </div>
              <div class="stat-info">
                <div class="stat-value">{{ completedVideoCount }}</div>
                <div class="stat-label">已完成学习</div>
              </div>
            </div>
          </el-card>
        </el-col>

        <el-col :span="6">
          <el-card class="stat-card" shadow="hover">
            <div class="stat-content">
              <div class="stat-icon" style="background-color: #34bfa3;">
                <i class="el-icon-warning-outline"></i>
              </div>
              <div class="stat-info">
                <div class="stat-value">{{ completedInspectCount }}/{{ totalInspectCount }}</div>
                <div class="stat-label">隐患排查完成率</div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <div class="dashboard-charts">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-card class="chart-card" shadow="hover">
            <div slot="header">
              <span>学习进度统计</span>
            </div>
            <div class="chart-container" ref="progressChart"></div>
          </el-card>
        </el-col>

        <el-col :span="12">
          <el-card class="chart-card" shadow="hover">
            <div slot="header">
              <span>最新学习记录</span>
            </div>
            <div class="record-list">
              <div v-for="record in recentRecords" :key="record.id" class="record-item">
                <div class="record-avatar">
                  <el-avatar :src="record.userAvatar" size="small"></el-avatar>
                </div>
                <div class="record-info">
                  <div class="record-user">{{ record.userName }}</div>
                  <div class="record-action">学习了《{{ record.videoTitle }}》</div>
                </div>
                <div class="record-time">{{ record.time }}</div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <div class="quick-actions">
      <el-card shadow="hover">
        <div slot="header">
          <span>快捷操作</span>
        </div>
        <div class="actions-grid">
          <el-button type="primary" icon="el-icon-plus" @click="$router.push('/video-manage')">
            新增视频
          </el-button>
          <el-button type="success" icon="el-icon-edit" @click="$router.push('/quiz-manage')">
            管理测验
          </el-button>
          <el-button type="warning" icon="el-icon-user" @click="$router.push('/user-manage')">
            用户管理
          </el-button>
          <el-button type="danger" icon="el-icon-warning-outline" @click="$router.push('/inspect-manage')">
            隐患排查
          </el-button>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as echarts from 'echarts'

export default {
  name: 'AdminDashboard',
  data() {
    return {
      recentRecords: [],
      chart: null
    }
  },
  computed: {
    ...mapGetters([
      'userCount',
      'videoCount',
      'completedVideoCount',
      'completedInspectCount',
      'totalInspectCount'
    ])
  },
  async created() {
    await this.loadData()
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose()
    }
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    async loadData() {
      try {
        await Promise.all([
          this.$store.dispatch('fetchUsers'),
          this.$store.dispatch('fetchVideos'),
          this.$store.dispatch('fetchStudyRecords'),
          this.$store.dispatch('fetchInspectItems')
        ])
        this.loadRecentRecords()
        this.$nextTick(() => {
          this.initChart()
        })
      } catch (error) {
        this.$message.error('加载数据失败：' + error.message)
      }
    },
    loadRecentRecords() {
      const records = this.$store.state.studyRecords
      const recentRecords = records.slice(0, 10).map(record => ({
        id: record.id,
        userName: record.userName || '未知用户',
        userAvatar: record.userAvatar || 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
        videoTitle: record.videoTitle || '未知视频',
        time: this.formatTime(record.watchTime)
      }))
      this.recentRecords = recentRecords
    },
    formatTime(time) {
      if (!time) return '未知'
      const now = new Date()
      const recordTime = new Date(time)
      const diff = Math.floor((now - recordTime) / 1000)
      if (diff < 60) return '刚刚'
      if (diff < 3600) return Math.floor(diff / 60) + '分钟前'
      if (diff < 86400) return Math.floor(diff / 3600) + '小时前'
      return Math.floor(diff / 86400) + '天前'
    },
    initChart() {
      if (!this.$refs.progressChart) return

      if (this.chart) {
        this.chart.dispose()
      }

      this.chart = echarts.init(this.$refs.progressChart)

      const studyRecords = this.$store.state.studyRecords || []
      const users = this.$store.state.users || []
      const videos = this.$store.state.videos || []

      // 统计每个用户的学习进度
      const userProgress = users.map(user => {
        const userRecords = studyRecords.filter(r => {
          const userId = r.userId || r.user_id
          return userId === user.id
        })
        const completedCount = userRecords.filter(r => {
          return r.completed === 1 || r.completed === true
        }).length
        const progress = videos.length > 0 ? Math.round((completedCount / videos.length) * 100) : 0
        return {
          name: user.name,
          completedCount,
          progress,
          totalVideos: videos.length
        }
      })

      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: function(params) {
            const data = userProgress[params[0].dataIndex]
            return `${data.name}<br/>已完成: ${data.completedCount}/${data.totalVideos}个内容<br/>完成率: ${data.progress}%`
          }
        },
        grid: {
          left: '3%',
          right: '10%',
          bottom: '3%',
          top: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          max: 100,
          axisLabel: {
            formatter: '{value}%'
          }
        },
        yAxis: {
          type: 'category',
          data: userProgress.map(u => u.name),
          inverse: true
        },
        series: [
          {
            name: '完成进度',
            type: 'bar',
            barWidth: '60%',
            itemStyle: {
              color: function(params) {
                const progress = userProgress[params.dataIndex].progress
                if (progress >= 80) return '#34bfa3'
                if (progress >= 50) return '#36a3f7'
                if (progress >= 30) return '#f5a623'
                return '#f4516c'
              },
              borderRadius: [0, 4, 4, 0]
            },
            label: {
              show: true,
              position: 'right',
              formatter: function(params) {
                return userProgress[params.dataIndex].progress + '%'
              }
            },
            data: userProgress.map(u => u.progress)
          }
        ]
      }

      this.chart.setOption(option)
      window.addEventListener('resize', this.handleResize)
    },
    handleResize() {
      if (this.chart) {
        this.chart.resize()
      }
    }
  }
}
</script>

<style scoped>
.dashboard {
  padding: 20px;
}

.dashboard-header h2 {
  margin: 0 0 8px 0;
  font-size: 24px;
  color: #333;
}

.dashboard-header p {
  margin: 0;
  color: #999;
  font-size: 14px;
}

.stats-cards {
  margin: 24px 0;
}

.stat-card {
  border-radius: 8px;
}

.stat-content {
  display: flex;
  align-items: center;
}

.stat-icon {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
}

.stat-icon i {
  font-size: 24px;
  color: white;
}

.stat-value {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  line-height: 1;
}

.stat-label {
  margin-top: 4px;
  color: #999;
  font-size: 14px;
}

.dashboard-charts {
  margin: 24px 0;
}

.chart-card {
  border-radius: 8px;
  height: 300px;
}

.chart-container {
  height: 240px;
}

.record-list {
  padding: 10px 0;
}

.record-item {
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
}

.record-item:last-child {
  border-bottom: none;
}

.record-avatar {
  margin-right: 12px;
}

.record-info {
  flex: 1;
}

.record-user {
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
}

.record-action {
  color: #666;
  font-size: 13px;
}

.record-time {
  color: #999;
  font-size: 12px;
}

.quick-actions {
  margin-top: 24px;
}

.actions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
}

.actions-grid .el-button {
  width: 100%;
  height: 80px;
  font-size: 16px;
}
</style>